// extracted by mini-css-extract-plugin
module.exports = {"arrow-container":"styles__arrow-container___378EE","arrow":"styles__arrow____Bo7Q","icon":"styles__icon___ONIVR"};